import {Segment} from "./segment";
import Submit from "../charts/submit";

function createElementFromDOMParser(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString.trim(), "text/html");

    // Extract the element from the body of the parsed document
    return doc.body.firstElementChild;
}


export class DimensionPanel {
    static #segment = null;
    static #searchResultsShowing = false;

    static show(segmentName, column) {

        // get segment data, if it exists, otherwise start fresh
        this.#segment = Segment.getSegment(segmentName);
        if (this.#segment === null) {
            this.#segment = {
                "name": segmentName,
                "column": column,
                "type": "is",
                "values": []
            };
        }

        let html = `
            <div id="dimension-panel-overlay">
                <div id="dimension-panel-container">
                    <div class="header-container">
                        <div class="panel-header"><span id="dimension-name">Unspecified</span></div>
                        <div><i class="close fa-solid fa-xmark"></i></div>
                    </div>
                    <div>
                        <div class="dimension-panel-section">
                            <select id="dimension-panel-segment-type">
                                <option value="is">is</option>
                                <option value="is not">is not</option>
                                <option value="contains">contains</option>
                                <option value="does not contain">does not contain</option>
                                <option value="starts with">starts with</option>
                                <option value="does not start with">does not start with</option>
                            </select>
                        </div>
                    </div>        
                    <div id="dimension-panel-segment-values">
                        <ul>                        
                        </ul>
                        <input id="dimension-search-box" type="text" placeholder="Search..." autocomplete="off" />
                        <div id="dimension-panel-segment-search-results" style="display: none;">
                            <ol>
                                <li>Chrome</li>                            
                                <li>Firefox</li>
                                <li>Safari</li>
                                <li>Chrome</li>                            
                                <li>Firefox</li>
                                <li>Safari</li>
                                <li>Chrome</li>                            
                                <li>Firefox</li>
                                <li>Safari</li>
                                <li>Chrome</li>                            
                                <li>Firefox</li>
                                <li>Safari</li>
                            </ol>
                        </div>
                    </div>       
                    <div>
                        <button id="dimension-panel-save-btn">Apply</button>
                        <button id="dimension-panel-remove-segment-btn">Delete</button>                    
                    </div> 
                </div>
            </div>
        `;

        let node = createElementFromDOMParser(html);
        let self = this;

        // select the segment type
        let typesDom = node.querySelector("#dimension-panel-segment-type").options;
        Array.from(typesDom).forEach(type => {
            if (type.value === this.#segment.type)
                type.selected = true;
        });

        // put name in panel
        node.querySelector("#dimension-name").innerText = segmentName;

        // listen for clicks on the closes button
        node.querySelector(".close").addEventListener("click", function () {
            DimensionPanel.hide();
        });
        document.body.appendChild(node);

        // change segment type listener
        node.querySelector("#dimension-panel-segment-type").addEventListener("change", function (event) {
            self.#segment.type = event.target.value;
        });

        node.querySelector("#dimension-search-box").addEventListener("click", function (event) {
            self.#searchDimension("");
        });

        // pressing enter when typing in a dimension value
        let delayTimer = null;
        node.querySelector("#dimension-search-box").addEventListener("keydown", function (event) {
            if (event.key === "Enter") {
                event.preventDefault();

                if (event.target.value !== "")
                    DimensionPanel.#addValue(event.target.value);

                event.target.value = "";
                self.#closeSearchDimension();
                return;
            }

            if (delayTimer != null)
                clearTimeout(delayTimer);
            delayTimer = setTimeout(function () {
                self.#searchDimension(event.target.value);
            }, 500);
        });

        // save button
        node.querySelector("#dimension-panel-save-btn").addEventListener("click", function () {

            // if there are values, add the segment. if empty we delete the segment
            if (self.#segment.values.length > 0)
                Segment.setSegment(self.#segment)
            else
                Segment.deleteSegment(segmentName);

            DimensionPanel.hide();
        });

        // remove segment button
        node.querySelector("#dimension-panel-remove-segment-btn").addEventListener("click", function () {
            Segment.deleteSegment(segmentName);
            DimensionPanel.hide();
        });

        // we need to call #addValue to update the dom, but it will re-append to values.  so clear values
        // before adding all the values
        let tmp = this.#segment.values;
        this.#segment.values = [];
        tmp.forEach(value => {
            this.#addValue(value);
        });
    }

    static hide() {
        document.querySelector("#dimension-panel-overlay").remove();
    }

    static #addValue(value) {
        let valuesDom = document.querySelector("#dimension-panel-segment-values ul");
        let liNode = createElementFromDOMParser(`<li><span>Unspecified</span><i class="fa-solid fa-xmark"></i></li>`)
        liNode.querySelector("span").innerText = value;

        // add click handler that will remove the value from the dom, and also remove it from the segment values
        let self = this;
        liNode.addEventListener("click", function (evt) {
            let index = Array.from(liNode.parentNode.children).indexOf(liNode);
            liNode.remove();
            self.#segment.values.splice(index, 1);
        });

        self.#segment.values.push(value);

        valuesDom.appendChild(liNode);


        // clear search box after adding a value
        document.querySelector("#dimension-search-box").value = "";
    }

    static async #searchDimension(searchStr) {
        let searchResults = document.querySelector("#dimension-panel-segment-search-results");
        let self = this;
        if (!self.#searchResultsShowing) {
            searchResults.style.display = "block";
            self.#searchResultsShowing = true;

            // register click handler that will automatically close the search dimension box
            window.setTimeout(function () {
                document.addEventListener("click", function (event) {
                    self.#closeSearchDimension();
                }, {once: true});
            }, 1);

        }

        self.#setSearchValues(["Loading.."]);

        // query for topn values
        let query = `select ${this.#segment.column} as 'value', count(*) as 'cnt' from pageviews where ${this.#segment.column} like '%${searchStr.replace("'", "\'")}%' and ${this.#segment.column} != '' order by 'cnt' desc limit 30`;

        const response = await Submit.submit(query, "data/query", false);
        let values = response.rows
            .map(row => row[0])
            .filter(value => !self.#segment.values.includes(value));

        if (values.length === 0)
            values = ["No matches.."];
        self.#setSearchValues(values);
    }

    static #setSearchValues(searchValues) {
        let searchResults = document.querySelector("#dimension-panel-segment-search-results");
        let olNode = searchResults.querySelector("ol");
        olNode.replaceChildren();

        let self = this;
        searchValues.forEach(value => {
           let liNode = document.createElement("li");
           liNode.textContent = value;
            liNode.addEventListener("click", function () {
                self.#addValue(value);
            });
           olNode.appendChild(liNode);
        });
    }

    static #closeSearchDimension() {
        if (!this.#searchResultsShowing)
            return;

        let searchResults = document.querySelector("#dimension-panel-segment-search-results");
        if (searchResults != null)
            searchResults.style.display = "none";

        this.#searchResultsShowing = false;
    }
}

window.addEventListener("load", function () {
    Array
        .from(document.querySelectorAll("*[data-dimension-name]"))
        .forEach(function (el) {
            el.addEventListener("click", function () {
                let dimensionName = el.getAttribute("data-dimension-name");
                let dimensionColumn = el.getAttribute("data-dimension-column");
                DimensionPanel.show(dimensionName, dimensionColumn);
            });
        });
});